import React, {useState} from 'react';
import {formatDateMDY, getUploadedImagePath, useAppState} from "@nutastic/nutastic-react-app";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import PageHeader from "../PageHeader";
import ArticleBox from "../ArticleBox";

const BlogPage = () => {
    const { posts = [], category, all_categories: blogCategories } = useAppState();
    const [ showSelector, setShowSelector ] = useState(true);
    const { description } = category;
    const componentClass = 'blog-page';

    const articles = posts.map( (article,i) => {
        return <ArticleBox
            title={article.title}
            content={article.excerpt || article.content}
            contentLimit={100}
            image={ getUploadedImagePath(article.image) }
            subtext={ formatDateMDY(article.date) }
            link={ `/article/${article.slug}` }
            className={ i === 0 ? 'blogArticle d-xl-none' : 'blogArticle'}
            lazyLoad={ true }
        />
    });

    const getLatestArticle = () => {
        const post = posts[0];
        const { title, content, excerpt, image, date, slug } = post;
        return <ArticleBox
            className={`${componentClass}__latest-article`}
            isLarge={ true }
            title={ title }
            content={ excerpt || content }
            contentLimit={150}
            image={ getUploadedImagePath(image) }
            subtext="Latest Article"
            link={ `/article/${slug}` }
        />;
    };

    const categorySelector = <Dropdown className="category-selector" isOpen={!showSelector} toggle={() => setShowSelector(!showSelector)}>
        <DropdownToggle caret className="category-selector__toggle">Change Category</DropdownToggle>
        <DropdownMenu className="category-selector__menu">
            <DropdownItem tag='a' href="/blog">All</DropdownItem>
            { blogCategories.filter(c => c.slug).map( c => {
                const { title, slug } = c;
                return <DropdownItem tag='a' href={`/blog/${slug}`}>{ title }</DropdownItem>
            })}
        </DropdownMenu>
    </Dropdown>;

    return <React.Fragment>
        <PageHeader title="Lj's Blog" subtext={ description } type={4}>
            { posts.length > 0 && getLatestArticle() }
            { categorySelector }
        </PageHeader>
        <div className="page-section page-section--padded">
            <div className='container'>
                <div className="clear clear--xxl d-none d-xl-block"/>
                <div className={`${componentClass}__articles`}>
                    { articles }
                </div>
            </div>
        </div>
    </React.Fragment>
};

export default BlogPage;
